
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface SubscriptionTier {
  tier: 'free' | 'standard' | 'premium' | 'ultimate' | 'service_provider';
  max_pets: number;
  max_storage_mb: number;
  max_storage_bytes: number;
  ai_tools_level: string;
  max_medical_records_total: number;
  allow_prescription_uploads: boolean;
  advanced_medical_tracking: boolean;
}

export const useSubscriptionTiers = () => {
  return useQuery({
    queryKey: ['subscription-tiers'],
    queryFn: async (): Promise<SubscriptionTier[]> => {
      const { data, error } = await supabase
        .from('tier_limits')
        .select('*')
        .order('tier');

      if (error) throw error;
      return data || [];
    },
  });
};
